/**
 * ============================================================================
 * SpeakerForm — Model (form values + RHF resolver)
 * ============================================================================
 * Uses shared createFormValidatorResolver. No Yup.
 * ============================================================================
 */

import { createFormValidatorResolver } from "@/helpers/rhfAdapters";

export interface SpeakerFormValues {
  fullName: string;
  phoneNumber: string;
  email: string;
  organization: string;
  linkedIn: string;
  countryCode: string;
  consent: boolean;
}

export interface SpeakerFormResponse {
  success: boolean;
  message: string;
}

export const SPEAKER_INITIAL_VALUES: SpeakerFormValues = {
  fullName: "",
  phoneNumber: "",
  email: "",
  organization: "",
  linkedIn: "",
  countryCode: "+91",
  consent: true,
};

export const SPEAKER_SECTION_NAME =
  "Would you like to join us as a speaker for our upcoming session?";

export function createSpeakerFormResolver() {
  return createFormValidatorResolver(Object.keys(SPEAKER_INITIAL_VALUES));
}
